export enum Ban {
  FoodFight = 'foodFight',
  Survival = 'survival',
  Team = 'team',
}
